// Service Configuration
// SECURITY NOTE: Only public keys are safe to expose in frontend code
// Private operations (SendGrid, Airtable) are handled by backend APIs in /api folder

export const serviceConfig = {
  // Supabase - Public anon key (protected by Row Level Security policies)
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL || '',
    key: process.env.REACT_APP_SUPABASE_ANON_KEY || '',
    configured: !!(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY)
  },

  // SendGrid - Handled by backend API (/api/send-email)
  // API key is stored securely in server environment variables
  // Frontend cannot verify if backend API key is configured
  sendgrid: {
    setupUrl: 'https://sendgrid.com',
    endpoint: '/api/send-email'
  },

  // Microsoft Clarity - Public analytics ID
  clarity: {
    projectId: process.env.REACT_APP_CLARITY_PROJECT_ID || '',
    configured: !!process.env.REACT_APP_CLARITY_PROJECT_ID,
    setupUrl: 'https://clarity.microsoft.com'
  },

  // Airtable - Handled by backend API (/api/airtable)
  // API key is stored securely in server environment variables
  // Frontend cannot verify if backend API key is configured
  airtable: {
    setupUrl: 'https://airtable.com',
    endpoint: '/api/airtable'
  }
}

// Setup Instructions
export const setupInstructions = {
  sendgrid: `
    ✅ Configured via backend API!
    
    Emails are sent through secure serverless function
    Professional email delivery with 99%+ inbox rate
    Beautiful HTML templates with personalization
    
    API keys stored securely in server environment variables
  `,
  
  clarity: `
    ✅ Already configured!
    
    Recording sessions and generating heatmaps automatically
    View insights in your Microsoft Clarity dashboard
  `,
  
  airtable: `
    ✅ Configured via backend API!
    
    Data flows automatically through secure serverless function:
    - Email signups (all sources)
    - Survey responses (structured data)
    - User interactions and analytics
    
    API keys stored securely in server environment variables
  `,

  supabase: `
    ✅ Already configured!
    
    Database tables created:
    - users (email collection)
    - user_sessions (session tracking)
    - survey_responses (survey data)
    - user_interactions (click tracking)
    
    Protected by Row Level Security (RLS) policies
  `
}

// Check which services are configured
// Note: Can only check frontend environment variables
// Backend services (SendGrid, Airtable) cannot be verified from frontend
export const getConfigurationStatus = () => {
  return {
    supabase: serviceConfig.supabase.configured,
    clarity: serviceConfig.clarity.configured,
  }
}

// Print setup status to console
export const logSetupStatus = () => {
  const status = getConfigurationStatus()
  
  console.log('🔧 Service Configuration Status:')
  console.log('✅ Supabase:', status.supabase ? 'Configured' : 'Not configured')
  console.log('📊 Microsoft Clarity:', status.clarity ? 'Configured' : 'Not configured')
  
  // Backend services - cannot be verified from frontend
  console.log('\n🔒 Backend Services (configured on server):')
  console.log('📧 SendGrid: Email API endpoint at /api/send-email')
  console.log('📋 Airtable: Database API endpoint at /api/airtable')
  console.log('   (These services will work or fail when called)')
  
  if (!status.supabase) {
    console.log('\n⚠️ Supabase:', setupInstructions.supabase)
  }
  
  if (!status.clarity) {
    console.log('\n⚠️ Clarity:', setupInstructions.clarity)
  }
} 